import { gql, useQuery } from '@apollo/client';

export const GET_EMPLOYEES_BY_GANTT = gql`
  query getEmployeesByGantt($ganttId: String!) {
    getEmployeesByGantt(ganttId: $ganttId) {
      _id
      ganttId
      firstName
      lastName
    }
  }
`;

export const useGetEmployeesByGantt = (ganttId: String) => {
  const { data, loading } = useQuery(GET_EMPLOYEES_BY_GANTT, {
    variables: { ganttId },
    skip: !ganttId,
  });

  const employees = data?.getEmployeesByGantt || [];

  return { employees, loading };
};
